import React from "react";
import { AddInvestmentContainer } from "../../../containers";

const AddInvestment = (props) => {
  return <AddInvestmentContainer {...props} />;
};

export default AddInvestment;
